// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const AntennaLookupWrapper = styled.div`
  -ms-flex-align: end;
  align-items: flex-end;
  margin: 1em;

  display: -ms-grid;
  -ms-grid-columns: (1fr 1em)[3] auto;
  -ms-grid-rows: auto 1em auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "antenna-code company-name antenna-model classification diameter antenna-lookup-search fa";
  grid-template-columns: repeat(5, 1fr) auto;
  grid-template-rows: auto auto;

  > .antenna-code {
    grid-area: antenna-code;
  }

  > .company-name {
    grid-area: company-name;
  }

  > .antenna-model {
    grid-area: antenna-model;
  }

  > .classification {
    grid-area: classification;
  }

  > .diameter {
    grid-area: diameter;
  }

  > .antenna-lookup-search {
    grid-area: antenna-lookup-search;
    margin-right: .5em;
  }

  > .fa {
    grid-area: fa;
    margin-right: 1em;
    width: 50px;
  }  
`
